module.exports = __webpack_public_path__ + "static/media/apurva_palwe.332e3022.png";